export default __webpack_public_path__ + "static/media/MERCEDES.64e211b8.png";